<div class="cv-notification-component" >
	<ng-container *ngIf="format === 'plain'">
		<div class="alert" [ngClass]="alertClass" [class.fixed]="fixed" [@animation]="animationState">
			<div (click)="onClickNotification()" class="message item-value" [innerHTML]="message"></div>
			<div *ngIf="!autoClose" class="close-container">
				<button class="btn btn-sm action-close" (click)="hideNotification()">
					<i class="fa fa-times" [ngClass]="alertClass"></i>
				</button>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="format === 'pretty'">
		<div class="toast {{type}}"
			[@animation]="animationState"
			[ngClass]="{
				'toast-md': size === 'md',
				'toast-lg': size === 'lg',
				'fixed': fixed,
				'show': show
			}">
			<div (click)="onClickNotification()" class="toast-body">
				<div class="close-container">
					<button class="btn btn-sm action-close" (click)="hideNotification()">
						<i class="fa fa-times"></i>
					</button>
				</div>

				<div class="toast-icon"
					[ngClass]="{
						'toast-icon-border': toastIcon.border
					}">
					<ng-container *ngIf="toastIcon.items.length === 1">
						<div class="icon-container">
							<ng-container *ngIf="toastIcon.custom">
								<img [src]="toastIcon.items[0].icon" class="img-fluid {{toastIcon.items[0].class}}">
							</ng-container>
							<ng-container *ngIf="!toastIcon.custom">
								<i class="{{toastIcon.items[0].style}} {{toastIcon.items[0].icon}} {{toastIcon.items[0].size}} {{toastIcon.items[0].class}} fa-fw"></i>
							</ng-container>
						</div>
					</ng-container>
					<ng-container *ngIf="toastIcon.items.length > 1">
						<span class="icon-container fa-stack {{toastIcon.size || 'fa-2x'}}">
							<ng-container *ngFor="let item of toastIcon.items">
								<i class="{{item.style}} {{item.icon}} {{item.size}} {{item.class}}"></i>
							</ng-container>
						</span>
					</ng-container>
				</div>

				<div class="toast-title" [innerHTML]="options.title"></div>
				<div class="toast-message message item-value" [innerHTML]="options.message"></div>
			</div>
			<div class="toast-progress-bar" *ngIf="autoClose">
				<div class="toast-progress" [style.width.%]="progress"></div>
			</div>
		</div>
	</ng-container>
</div>